import { type JSX } from "react";

import { useFlags } from "../utils/feature-flags";

interface FeatureProps {
  flag: string;
  fallback: () => JSX.Element;
  children: JSX.Element;
}

/**
 * Feature component lets you declare a fallback if a flag is false. If true
 * children of the component will be rendered.
 *
 * ```
 * <Feature flag="newThing" fallback={() => <Navigate to="/" />}>
 *   <div>Only rendered when flag is on!</div>
 * </Feature>
 * ```
 */
export const Feature = ({ flag, fallback, children }: FeatureProps) => {
  const flags = useFlags();
  if (flags[flag]) {
    return children;
  }
  return fallback();
};
